export function normalizePhoneNumber(rawPhoneNumber: string): string {
  const digitsOnly = rawPhoneNumber.replace(/\D/g, "");
  const withCountryCode = digitsOnly.length === 9 ? `48${digitsOnly}` : digitsOnly;
  return withCountryCode ? `+${withCountryCode}` : "";
}
